// import React, { useState } from "react";
// import { Button, styled, Dialog, DialogTitle, DialogActions, IconButton } from '@mui/material';
// import CloseIcon from "@mui/icons-material/Close";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { useDispatch } from "react-redux";
// import { CandidateAddRatingAction } from "./../../../Redux/action/CandidateAddRatingAction";
// import { MdCancel } from "react-icons/md";

// const BootstrapDialog = styled(Dialog)(({ theme }) => ({
//     "& .MuiDialogContent-root": {
//         padding: theme.spacing(2),
//     },
//     "& .MuiDialogActions-root": {
//         padding: theme.spacing(1),
//     },
// }));

// const BootstrapDialogTitle = (props) => {
//     const { children, onClose, ...other } = props;

//     return (
//         <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
//             {children}
//             {onClose ? (
//                 <IconButton
//                     aria-label="close"
//                     onClick={onClose}
//                     sx={{
//                         position: "absolute",
//                         right: 8,
//                         top: 8,
//                         color: (theme) => theme.palette.grey[500],
//                     }}
//                 >
//                     <CloseIcon />
//                 </IconButton>
//             ) : null}
//         </DialogTitle>
//     );
// };

// const CancelInterview = (props) => {
//     const [open, setOpen] = useState(false);
//     const [error, setError] = useState(false);
//     const [data, setData] = useState({
//         interviewCancellationReason: "",
//         candidateInterviewStatus: "",
//         ratings: "",
//     });
//     const [selectedOption, setSelectedOption] = useState(null);

//     const options = [
//         { id: 1, label: "Position filled" },
//         { id: 2, label: "Schedule conflict" },
//         { id: 3, label: "Reevaluation" },
//         { id: 4, label: "Company restructuring" },
//         { id: 5, label: "Budget constraints" },
//         { id: 6, label: "Internal candidate selected" },
//         { id: 7, label: "Other" },
//     ];

//     const handleCheckboxChange = (label) => {
//         setSelectedOption(label);
//     };
//     // const { interviewCancellationReason, candidateInterviewStatus, ratings } = data;
//     // const rating = parseInt(ratings);
//     const interviewId = props.data

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     let dispatch = useDispatch();
//     // const handleInputChange = (e) => {
//     //     let { name, value } = e.target;
//     //     setData({ ...data, [name]: value });
//     // };

//     const handleSubmit = (e) => {
//         e.preventDefault();

//         if (selectedOption === "" || selectedOption === null) {
//             setError("Please select one option.")
//         } else {
//             let content = {
//                 interviewId,
//                 interviewCancellationReason: selectedOption,
//                 interviewStatus: "CANCELLED",
//             };
//             dispatch(CandidateAddRatingAction(content));
//             setError("")
//         }
//     };

//     return (
//         <>
//             <ToastContainer />
//             <BootstrapDialog
//                 onClose={handleClose}
//                 aria-labelledby="customized-dialog-title"
//                 open={open}
//             >
//                 <BootstrapDialogTitle
//                     id="customized-dialog-title"
//                     onClose={handleClose}
//                 >
//                     Cancel Interview
//                 </BootstrapDialogTitle>
//                 <form onSubmit={handleSubmit}>
//                     <div style={{padding:20 ,marginTop:"-20px"}}>
//                         <h6 style={{color:"red"}}>{error}</h6>
//                         {options.map((option) => (
//                             <div key={option.id}>
//                                 <input
//                                     type="checkbox"
//                                     id={`checkbox-${option.id}`}
//                                     value={option.id}
//                                     checked={selectedOption === option.label}
//                                     onChange={() => handleCheckboxChange(option.label)}
//                                     style={{cursor:"pointer"}}
//                                 />
//                                 <label htmlFor={`checkbox-${option.id}`} style={{padding:5}}>{option.label}</label>
//                             </div>
//                         ))}
//                         {/*<p>Selected option: {selectedOption}</p>*/}
//                     </div>
//                     <DialogActions>
//                         <Button autoFocus type="submit">
//                             Save changes
//                         </Button>
//                     </DialogActions>
//                 </form>
//             </BootstrapDialog>
//             <div onClick={handleClickOpen}><MdCancel size={35} color="#ed3535" cursor="pointer" /></div>
//         </>
//     );
// };

// export default CancelInterview;

//================== ===================== ================================

import React, { useState } from "react";
import { Button, styled, Dialog, DialogTitle, DialogActions, IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
import { CandidateAddRatingAction } from "./../../../Redux/action/CandidateAddRatingAction";
import { MdCancel } from "react-icons/md";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

const CancelInterview = (props) => {
    const [open, setOpen] = useState(false);
    const [error, setError] = useState(false);
    const [data, setData] = useState({
        interviewCancellationReason: "",
        candidateInterviewStatus: "",
        ratings: "",
    });
    const [selectedOption, setSelectedOption] = useState(null);

    const options = [
        { id: 1, label: "Position filled" },
        { id: 2, label: "Schedule conflict" },
        { id: 3, label: "Reevaluation" },
        { id: 4, label: "Company restructuring" },
        { id: 5, label: "Budget constraints" },
        { id: 6, label: "Internal candidate selected" },
        { id: 7, label: "Other" },
    ];

    const handleCheckboxChange = (label) => {
        setSelectedOption(label);
    };
    // const { interviewCancellationReason, candidateInterviewStatus, ratings } = data;
    // const rating = parseInt(ratings);
    const interviewId = props.data

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let dispatch = useDispatch();
    // const handleInputChange = (e) => {
    //     let { name, value } = e.target;
    //     setData({ ...data, [name]: value });
    // };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (selectedOption === "" || selectedOption === null) {
            setError("Please select one option.")
        } else {
            let content = {
                interviewId,
                interviewCancellationReason: selectedOption,
                interviewStatus: "CANCELLED",
            };
            dispatch(CandidateAddRatingAction(content));
            setError("")
        }
    };

    return (
        <>
            <ToastContainer />
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle
                    id="customized-dialog-title"
                    onClose={handleClose}
                >
                    Cancel Interview
                </BootstrapDialogTitle>
                <form onSubmit={handleSubmit}>
                    <div style={{padding:20 ,marginTop:"-20px"}}>
                        <h6 style={{color:"red"}}>{error}</h6>
                        {options.map((option) => (
                            <div key={option.id}>
                                <input
                                    type="checkbox"
                                    id={`checkbox-${option.id}`}
                                    value={option.id}
                                    checked={selectedOption === option.label}
                                    onChange={() => handleCheckboxChange(option.label)}
                                    style={{cursor:"pointer"}}
                                />
                                <label htmlFor={`checkbox-${option.id}`} style={{padding:5}}>{option.label}</label>
                            </div>
                        ))}
                        {/*<p>Selected option: {selectedOption}</p>*/}
                    </div>
                    <DialogActions>
                        <Button autoFocus type="submit">
                            Save changes
                        </Button>
                    </DialogActions>
                </form>
            </BootstrapDialog>
            <div onClick={handleClickOpen}><MdCancel size={35} color="#ed3535" cursor="pointer" /></div>
        </>
    );
};

export default CancelInterview;